

$('body').on('click', '.pagination-btn', async (event) => { 
    if($(event.target).hasClass('next-btn')){
        let targetElement = $('a.pagination-btn.active').parent().next().find('a.pagination-btn');
        
        $('a.pagination-btn.active').removeClass('bg-primary text-white active').addClass('text-primary');
        targetElement.removeClass('text-primary')
        targetElement.addClass('bg-primary text-white active');

    }else if($(event.target).hasClass('previous-btn')) {
        let targetElement = $('a.pagination-btn.active').parent().prev().find('a.pagination-btn');
        
        $('a.pagination-btn.active').removeClass('bg-primary text-white active').addClass('text-primary');
        targetElement.removeClass('text-primary')
        targetElement.addClass('bg-primary text-white active');

       
    }else{
        $('a.pagination-btn.active').removeClass('bg-primary text-white active').addClass('text-primary');
        $(event.target).removeClass('text-primary')
        $(event.target).addClass('bg-primary text-white active');

    }
    
});

$('#q2a-external-user').on('click',(event)=>{
    var newWindow = window.open("", "_blank");
    newWindow.location.href = api.q2a_url+'?token='+  window.localStorage.getItem('access_token');
   
});


$('body').on('click', '#alert-close-btn', async (event) => { 
    $('.alert-container').html('');
});

$('body').on('click', '.message', async (event) => { 
    $('.message').html('');
});

$('#addcommentmodal').on('hidden.bs.modal', function () {
    $('#chat-content-box').html('');
  })




var me_data = JSON.parse(localStorage.getItem("meData"));
if(me_data != null){
   const full_name= me_data.first_name+' '+me_data.last_name;
    $("#user_name").empty().append(full_name);
}



